'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _antd = require('antd');

var _FieldSelect = require('./FieldSelect');

var _FieldSelect2 = _interopRequireDefault(_FieldSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DisplayDateSettingsModal = function (_Component) {
	_inherits(DisplayDateSettingsModal, _Component);

	function DisplayDateSettingsModal(props) {
		_classCallCheck(this, DisplayDateSettingsModal);

		var _this = _possibleConstructorReturn(this, (DisplayDateSettingsModal.__proto__ || Object.getPrototypeOf(DisplayDateSettingsModal)).call(this, props));

		_this.state = {
			formType: undefined,
			startDate: undefined,
			quantity: 1,
			isPremium: false,
			isFreeOnDisplayDate: false
		};

		_this.submit = _this.submit.bind(_this);
		return _this;
	}

	_createClass(DisplayDateSettingsModal, [{
		key: 'submit',
		value: function submit() {
			var _state = this.state,
			    formType = _state.formType,
			    startDate = _state.startDate,
			    quantity = _state.quantity,
			    isFreeOnDisplayDate = _state.isFreeOnDisplayDate,
			    isPremium = _state.isPremium,
			    displayOnDate = _state.displayOnDate;


			var list = [];
			var row = null;
			for (var i = 0; i < quantity; i++) {
				row = {
					type: formType,
					title: '',
					value: '',
					isPremium: isPremium
				};

				if (displayOnDate) {
					row.displayDate = (0, _moment2.default)(startDate).add(i, 'day').format('YYYY-MM-DD');
					row.isFreeOnDisplayDate = isFreeOnDisplayDate;
					row.title = 'Dia ' + (0, _moment2.default)(startDate).add(i, 'day').format('DD/MM');
				}

				list.push(row);
			}

			this.props.addFields(list);

			this.state = {
				formType: undefined,
				startDate: undefined,
				quantity: 1,
				isPremium: false,
				isFreeOnDisplayDate: false
			};

			return Promise.resolve();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    isSettingsVisible = _props.isSettingsVisible,
			    cancel = _props.cancel;
			var _state2 = this.state,
			    formType = _state2.formType,
			    startDate = _state2.startDate,
			    quantity = _state2.quantity,
			    isFreeOnDisplayDate = _state2.isFreeOnDisplayDate,
			    isPremium = _state2.isPremium,
			    displayOnDate = _state2.displayOnDate;


			return _react2.default.createElement(
				_antd.Modal,
				{
					visible: isSettingsVisible,
					maskClosable: false,
					onOk: this.submit,
					onCancel: function onCancel() {
						cancel();
						return Promise.resolve();
					}
				},
				_react2.default.createElement(
					_antd.Row,
					{ type: 'flex', style: { width: '90%', justifyContent: 'center' }, gutter: [0, 15] },
					_react2.default.createElement(
						_antd.Col,
						{ md: 24, xs: 24 },
						_react2.default.createElement(_FieldSelect2.default, {
							value: formType,
							onChange: function onChange(e) {
								return _this2.setState({ formType: e });
							}
						})
					),
					_react2.default.createElement(
						_antd.Col,
						{ md: 24, xs: 24 },
						_react2.default.createElement(
							'label',
							{ style: { marginRight: 5 } },
							'Quantidade'
						),
						_react2.default.createElement(_antd.InputNumber, {
							value: quantity,
							onChange: function onChange(value) {
								return _this2.setState({ quantity: value });
							}
						})
					),
					_react2.default.createElement(
						_antd.Col,
						{ md: 24, xs: 24 },
						_react2.default.createElement(
							_antd.Checkbox,
							{
								checked: isPremium,
								onChange: function onChange(e) {
									return _this2.setState({ isPremium: e.target.checked });
								}
							},
							'Conte\xFAdo Premium'
						)
					),
					_react2.default.createElement(
						_antd.Col,
						{ md: 24, xs: 24 },
						_react2.default.createElement(
							_antd.Checkbox,
							{
								checked: displayOnDate,
								onChange: function onChange(e) {
									return _this2.setState({
										displayOnDate: e.target.checked
									});
								}
							},
							'Liberar somente no dia especif\xEDcado'
						)
					),
					displayOnDate && _react2.default.createElement(
						_react2.default.Fragment,
						null,
						_react2.default.createElement(
							_antd.Col,
							{ md: 24, xs: 24 },
							_react2.default.createElement(
								'label',
								{ style: { marginRight: 5 } },
								'Data de In\xEDcio'
							),
							_react2.default.createElement(_antd.DatePicker, {
								value: startDate,
								format: 'DD/MM/YYYY',
								onChange: function onChange(start) {
									_this2.setState({
										startDate: start
									});
								}
							})
						),
						_react2.default.createElement(
							_antd.Col,
							{ md: 24, xs: 24 },
							_react2.default.createElement(
								_antd.Checkbox,
								{
									checked: isFreeOnDisplayDate,
									onChange: function onChange(e) {
										return _this2.setState({
											isFreeOnDisplayDate: e.target.checked,
											isPremium: e.target.checked ? true : isPremium
										});
									}
								},
								'Conte\xFAdo Gratuito no dia da libera\xE7\xE3o'
							)
						)
					)
				)
			);
		}
	}]);

	return DisplayDateSettingsModal;
}(_react.Component);

exports.default = DisplayDateSettingsModal;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/genericMaterialAreas/ContentTree/MoreSettingsModal.js
// module id = 3236
// module chunks = 0